import {
  CreateCustomerVehicleRequest,
  CustomerVehicleReduced,
} from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import {
  useCreateCustomerVehicle,
  useUpdateCustomerVehicle,
} from '@/core/domain/people/CustomerVehicles/CustomerVehicles.hooks';
import VehicleModal from '@/components/_common/_VehicleModal';
import { VehicleReturnValues } from '@/components/_common/_VehicleModal/VehicleModal.types';
import { uploadArchive } from '@/core/domain/archive/Archive/Archive.service';

interface CustomerVehicleSimplifiedRegisterModalProps {
  visible: boolean;
  handleVisible: () => void;
  customerId?: number;
  vehicleId?: number;
  onFinish?: (vehicle: CustomerVehicleReduced) => void;
}

function CustomerVehicleSimplifiedRegisterModal({
  visible,
  handleVisible,
  customerId,
  vehicleId,
  onFinish,
}: CustomerVehicleSimplifiedRegisterModalProps) {
  const createMutation = useCreateCustomerVehicle(customerId);
  const updateMutation = useUpdateCustomerVehicle(customerId);

  const handleOk = async (values: VehicleReturnValues) => {
    let image = values.image;

    if (!!values.imageUpload) {
      const result = await uploadArchive({
        file: [values.imageUpload as Blob],
        isPublic: false,
      });

      image = result.filePath;
    }

    const obj: CreateCustomerVehicleRequest = {
      model: {
        id: values.modelId,
        brand: { id: values.brandId, image: values.model?.brand.image },
      },
      fuel: { id: values.fuelId },
      color: { id: values.colorId },
      licensePlate: values.licensePlate,
      yearFabrication: Number(values.yearFabrication),
      yearModel: Number(values.yearModel),
      chassi: values.chassi,
      fleet: values.fleet,
      km: values.km,
      renavam: values.renavam,
      type: values?.type,
      active: true,
      accessories: values.accessories || [],
      image,
      cylinders: values.cylinders,
      engineCapacity: values.engineCapacity,
      engineName: values.engineName,
      engineTechnicalCode: values.engineTechnicalCode,
      horsePower: values.horsePower,
      release: values.release,
      valves: values.valves,
      line: values.line,
      airIntake: values.airIntake,
      rearBrake: values.rearBrake,
      frontBrake: values.frontBrake,
      brakeSystem: values.brakeSystem,
      steeringSystem: values.steeringSystem,
      tractionSystem: values.tractionSystem,
      injectionSystem: values.injectionSystem,
      transmissionType: values.transmissionType,
      engineConfiguration: values.engineConfiguration,
    };

    let result;

    if (vehicleId) {
      result = await updateMutation.mutateAsync({ ...obj, id: vehicleId });
    } else {
      result = await createMutation.mutateAsync(obj);
    }

    if (onFinish && result) {
      onFinish({
        brandName: result.model.brand.name,
        customerId: result.customerId,
        id: result.id,
        km: result.averageKm,
        licensePlate: result.licensePlate,
        modelName: result.model.name,
        yearFabrication: result.yearFabrication,
        yearModel: result.yearModel,
        fuel: result.fuel,
      });
    }

    handleVisible();
  };

  return (
    <>
      <VehicleModal
        vehicleId={vehicleId}
        customerId={customerId}
        onCancel={handleVisible}
        onOk={handleOk}
        open={visible}
      />
    </>
  );
}

export default CustomerVehicleSimplifiedRegisterModal;
